import React from "react";
import { Col, Row, Table } from "react-bootstrap";
import { number, object } from "prop-types";
import { testGraphHeights } from "./constants";

const RawScoreDistributionGraph = ({
  testId,
  scoreRangeToDisplay,
  rawScore,
}) => {
  const rangeMax = scoreRangeToDisplay && Number(scoreRangeToDisplay.rangeMax);
  const rangeMin = scoreRangeToDisplay && Number(scoreRangeToDisplay.rangeMin);
  const scoreRangeName = scoreRangeToDisplay && scoreRangeToDisplay.rangeName;

  const generateGraph = () => {
    if (!testGraphHeights[testId]) {
      return null;
    }

    const barHeights = testGraphHeights[testId];
    const scoreRangeWidth = scoreRangeName
      ? `${100 * (rangeMax - rangeMin)}%`
      : "";
    const scoreRangeText = scoreRangeName
      ? `${scoreRangeName} Range: ${rangeMin} - ${rangeMax}`
      : "";

    const graphBars = [];
    const graphLabels = [];
    barHeights.forEach((height, i) => {
      graphBars.push(
        <td
          className={`distribution-score-range-cell ${addInRangeClass(i)}`}
          key={i} // eslint-disable-line react/no-array-index-key
          style={{
            width: `${100 / barHeights.length}%`,
            "--range-width": scoreRangeWidth,
          }}
          rangetitle={scoreRangeText} // eslint-disable-line react/no-unknown-property -- custom attribute
        >
          <div
            className="w-100"
            style={{
              backgroundColor: i + 1 === rawScore ? "#001F4E" : "#E5E8ED",
              height: `${height * 1.5}px`,
            }}
          />
        </td>
      );
      graphLabels.push(
        <td
          key={i} // eslint-disable-line react/no-array-index-key
          className="text-center border-0"
          style={{ padding: "5px 0px" }}
        >
          <span style={{ fontSize: "10px", color: "#b1b1b3" }}>{i + 1}</span>
        </td>
      );
    });
    return [
      <tr key="graphBars">{graphBars}</tr>,
      <tr key="graphLabels">{graphLabels}</tr>,
    ];
  };

  const addInRangeClass = (height) => {
    let className = "";
    if (height + 1 >= rangeMin && height + 1 <= rangeMax) {
      className += "distribution-cell-in-range ";
      if (height + 1 === rangeMin || (rangeMin === 0 && height === 0)) {
        className += "distribution-cell-in-range-first";
      } else if (height + 1 === rangeMax) {
        className += "distribution-cell-in-range-last";
      }
    }
    return className;
  };

  return (
    <Col>
      <Row style={{ paddingTop: "10px" }}>
        <Table className="m-0" style={{ height: "300px" }}>
          <tbody>{generateGraph()}</tbody>
        </Table>
      </Row>
    </Col>
  );
};

RawScoreDistributionGraph.propTypes = {
  testId: number,
  rawScore: number,
  scoreRangeToDisplay: object,
};

export default RawScoreDistributionGraph;
